import { UiSchema, WidgetProps } from '@rjsf/utils';
import { KnownUploadImageDtoCategory } from '@groundfloor-platform/mgmt-service-g-sdk';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormImageUpload } from '../shared/dynamic-form-image-upload';
import { DynamicFormColourInput } from '../shared/dynamic-form-colour-input';

const uiGrid: UIGridElement[] = [
  { title: 'Base Style', fields: { themeHome: 6, themeOtherScreens: 6 } },
  { title: 'Footer Style', fields: { themeHomeFooter: 6, themeSessionFooter: 6 } },

  { title: 'Logos', fields: { logoType: 2, logoSrc: 10 } },
  { fields: { logoHomeScreenHeightPx: 6, logoHomeScreenPositionYPx: 6 } },
  { fields: { poweredByTheme: 6 } },

  { title: 'Backgrounds', fields: { backgroundHome: 6, backgroundSession: 6 } },

  {
    title: 'Colours — light',
    fields: { colorsLightPrimary: 3, colorsLightPrimaryVariant: 3, colorsLightOnPrimary: 3, colorsLightOnSecondary: 3 }
  },
  {
    title: 'Colours — dark',
    fields: { colorsDarkPrimary: 3, colorsDarkPrimaryVariant: 3, colorsDarkOnPrimary: 3, colorsDarkOnSecondary: 3 }
  }
];

const kioskImageOptions = { isPublic: true, category: KnownUploadImageDtoCategory.Kiosk };
const imageWidget = (props: WidgetProps) => <DynamicFormImageUpload {...props} />;
const colourWidget = (props: WidgetProps) => <DynamicFormColourInput {...props} />;

export const kioskThemeSettingsFormUISchema: UiSchema = {
  'ui:submitButtonOptions': { norender: true },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,

  logoSrc: { 'ui:widget': imageWidget, 'ui:options': kioskImageOptions },
  backgroundHome: { 'ui:widget': imageWidget, 'ui:options': kioskImageOptions },
  backgroundSession: { 'ui:widget': imageWidget, 'ui:options': kioskImageOptions },

  colorsLightPrimary: { 'ui:widget': colourWidget },
  colorsLightPrimaryVariant: { 'ui:widget': colourWidget },
  colorsLightOnPrimary: { 'ui:widget': colourWidget },
  colorsLightOnSecondary: { 'ui:widget': colourWidget },
  colorsDarkPrimary: { 'ui:widget': colourWidget },
  colorsDarkPrimaryVariant: { 'ui:widget': colourWidget },
  colorsDarkOnPrimary: { 'ui:widget': colourWidget },
  colorsDarkOnSecondary: { 'ui:widget': colourWidget }
};
